import React from "react";
import { SaveButton, useNotify, useRefresh } from "react-admin";
import { useParams } from "react-router";
import { useFormContext } from "react-hook-form";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SaveButtonProfessors = ({ setIsProfessorEditing }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const { id } = useParams();
  const { getValues } = useFormContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSaveClick = async () => {
    const formDataToSave = getValues();

    const commissions = formDataToSave.commissions || [];
    const professors = commissions.flatMap((commission, commissionIndex) => {
      const commissionNumber = commission.commissionNumber || commissionIndex + 1;
      return (commission.professors || []).map(professor => ({
        professorEmployeeId: professor.professorEmployeeId,
        role: professor.role,
        commissionNumber,
      }));
    });
    const { commissions: _, ...rest } = formDataToSave;

    const payload = {
      ...rest,
      professors,
    };

    try {
      await dataProvider.customRequest(studentRequests.updateSessionExamProfessors(id), payload, "PUT");
      refresh();
      notify("Записът е редактиран", { type: "success" });
      setIsProfessorEditing(false);
    } catch (e) {
      notifyError(e);
      handleConflictError(e);
    }
  };

  return (
    <>
      <SaveButton
        label="Запази"
        onClick={handleSaveClick}
        size="small"
      />
      <ConflictErrorDialog />
    </>
  );
};
export default SaveButtonProfessors;
